import React, { useEffect, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
} from "@mui/material";
import { FileItem } from "./styled";
import { toast } from "react-toastify";
import api from "../../api/axios";

export const ProfessionalAllDocsModal = ({ open, onClose, professional }) => {
  const [occurrenceFiles, setOccurrenceFiles] = useState([]);

  const handleCurriculumClick = (url) => {
    window.open(url, "_blank");
  };

  const handleCourseClick = (course) => {
    if (course.certificate) {
      window.open(course.certificate, "_blank");
    } else {
      toast.warn("Não foi feito o upload desse certificado");
    }
  };

  const handleOccFileClick = (url) => {
    window.open(url, "_blank");
  };

  const getOccurrenceFiles = async () => {
    try {
      const { data } = await api.get(
        "/occurrence_file/get-by-professional/" + professional._id,
      );
      setOccurrenceFiles(data);
    } catch (err) {
      toast.error("Ocorreu um erro");
      console.error(err);
    }
  };

  const handleClose = () => {
    setOccurrenceFiles([]);
    onClose();
  };

  useEffect(() => {
    if (open && professional) getOccurrenceFiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [professional, open]);

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth={false}
      PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "700px",
          minWidth: "300px",
        },
      }}
    >
      <DialogTitle textAlign="center">
        {"Documentos do(a) profissional"}
      </DialogTitle>
      <DialogContent>
        <Stack
          sx={{
            padding: "10px 20px",
            minWidth: "300px",
            width: "100%",
            gap: "1.5rem",
            display: "flex",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <h2>{"Currículo:"}</h2>
            {professional && professional.curriculum ? (
              <FileItem
                onClick={() => handleCurriculumClick(professional.curriculum)}
              >
                <span
                  style={{ color: "#104467", fontWeight: "bold" }}
                >{`Currículo - ${professional.name}${professional.cpf ? " (" + professional.cpf + ")" : ""}`}</span>
              </FileItem>
            ) : (
              <span>{"Esse profissional não possui currículo cadastrado"}</span>
            )}
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <h2>{"Certificados:"}</h2>
            {professional &&
            professional.courses &&
            professional.courses.length > 0 ? (
              professional.courses.map((course) => (
                <FileItem
                  key={`course${professional.courses.indexOf(course)}`}
                  onClick={() => handleCourseClick(course)}
                >
                  <span
                    style={{ color: "#104467", fontWeight: "bold" }}
                  >{`${course.course} | ${course.deliveryMode}`}</span>
                  <span>{`${course.origin} (${course.year})`}</span>
                </FileItem>
              ))
            ) : (
              <span>
                {"Esse profissional não possui certificados cadastrados"}
              </span>
            )}
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <h2>{"Documentos de ocorrências:"}</h2>
            {occurrenceFiles.length > 0 ? (
              occurrenceFiles.map((occ) => (
                <FileItem onClick={() => handleOccFileClick(occ.url)}>
                  <span style={{ color: "#104467", fontWeight: "bold" }}>
                    {occ.name}
                  </span>
                </FileItem>
              ))
            ) : (
              <span>
                {"Esse profissional não possui nenhum arquivo nas ocorrências"}
              </span>
            )}
          </div>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: "1.25rem" }}>
        <Button sx={{ color: "#104467" }} onClick={handleClose}>
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
